// Nova — Legal copy (Privacy Policy & Terms of Service)
//
// Launch-grade templates personalised with the operator's details.
// IMPORTANT: This is a comprehensive template, not legal advice.
// A licensed attorney should review before major jurisdictions expansion.

export const LEGAL_OPERATOR       = "Chris Minhi";
export const LEGAL_CONTACT_EMAIL  = "minhichris64@gmail.com";
export const LEGAL_JURISDICTION   = "Pennsylvania, United States of America";
export const LEGAL_LAST_UPDATED   = "March 1, 2026";
export const LEGAL_EFFECTIVE_DATE = "March 1, 2026";

// Re-used in both Privacy + Terms.
export const APP_NAME       = "Nova";
export const APP_PUBLISHER  = LEGAL_OPERATOR;
export const APP_WEB_URL    = "https://maker-hub-213.emergent.host";

// Sub-processors — kept in one place so both the Privacy Policy and the
// App Store privacy answers stay in sync.
export const SUBPROCESSORS = [
  { name: "Stripe, Inc.",                purpose: "Payment processing, subscription billing, invoicing, customer portal", country: "United States" },
  { name: "OpenAI, LLC",                 purpose: "Vision analysis, coaching text generation",                              country: "United States" },
  { name: "Anthropic, PBC",              purpose: "Vision analysis, coaching text generation",                              country: "United States" },
  { name: "Google LLC (Gemini)",         purpose: "Image analysis (nutrition, style, skin) when routed",                    country: "United States" },
  { name: "MongoDB, Inc. (Atlas)",       purpose: "Encrypted database hosting",                                             country: "United States" },
  { name: "Emergent Labs",               purpose: "Application hosting, containerised runtime",                             country: "United States" },
  { name: "Apple Inc. (APNs)",           purpose: "Push notification delivery on iOS (if you enable push)",                 country: "United States" },
  { name: "Google LLC (FCM)",            purpose: "Push notification delivery on Android/web (if you enable push)",         country: "United States" },
];
